var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 956448964"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.38565 3.53188C6.6555 3.53188 6.87425 3.31313 6.87425 3.04328V2.99044C6.87425 2.72059 6.6555 2.50184 6.38565 2.50184H4.74811C4.60955 2.50184 4.49721 2.38951 4.49721 2.25094V0.613402C4.49721 0.343557 4.27846 0.124804 4.00862 0.124804H3.95577C3.68592 0.124804 3.46717 0.343556 3.46717 0.613402V2.25094C3.46717 2.38951 3.35484 2.50184 3.21627 2.50184H1.57873C1.30889 2.50184 1.09014 2.72059 1.09014 2.99044V3.04328C1.09014 3.31313 1.30889 3.53188 1.57873 3.53188H3.21627C3.35484 3.53188 3.46717 3.64421 3.46717 3.78278V5.42032C3.46717 5.69016 3.68592 5.90892 3.95577 5.90892H4.00862C4.27846 5.90892 4.49721 5.69016 4.49721 5.42032V3.78278C4.49721 3.64421 4.60954 3.53188 4.74811 3.53188H6.38565Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.237696
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.28527 4.50915C8.28527 4.94674 8.64 5.30147 9.07759 5.30147H14.4139C14.8515 5.30147 15.2062 4.94674 15.2062 4.50915V3.71676C15.2062 3.27917 14.8515 2.92444 14.4139 2.92444H9.07759C8.64 2.92444 8.28527 3.27917 8.28527 3.71676V4.50915ZM2.13281 8.47083C2.13281 8.03324 2.48755 7.67851 2.92513 7.67851H14.4139C14.8515 7.67851 15.2062 8.03324 15.2062 8.47083V9.26322C15.2062 9.70081 14.8515 10.0555 14.4139 10.0555H2.92513C2.48755 10.0555 2.13281 9.70081 2.13281 9.26322V8.47083ZM15.2062 13.2249C15.2062 12.7873 14.8515 12.4326 14.4139 12.4326H2.92513C2.48755 12.4326 2.13281 12.7873 2.13281 13.2249V14.0173C2.13281 14.4549 2.48755 14.8096 2.92513 14.8096H14.4139C14.8515 14.8096 15.2062 14.4549 15.2062 14.0173V13.2249Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTop);
export default __webpack_public_path__ + "static/media/addTop.93d5ec3f8cc00e32cc860de4f5d834bd.svg";
export { ForwardRef as ReactComponent };